<template>
  <div
    :style="`width: ${isCollapse ? '64px' : '100%'}; ${isCollapse ? 'transition: width 0.3s ease;' : 'transition: width 0.3s ease 0.3s;'} display: flex; align-items: center; position: relative;`"
  >
    <el-menu
      :default-active="$route.name"
      class="el-menu-vertical-demo"
      @select="handleSelect"
      :collapse="isCollapse"
      style="position: relative;"
    >
      <el-menu-item index="todos" v-can="'todo.view'">
        <i class="el-icon-finished"></i>
        <span>Todo lista</span>
      </el-menu-item>
      <el-menu-item index="todo-recurring-patterns" v-can="'todo.view'">
        <i class="el-icon-refresh-left"></i>
        <span>Ismétlődő szabályok</span>
      </el-menu-item>
    </el-menu>
    <el-button
      :icon="isCollapse ? 'el-icon-arrow-left' : 'el-icon-arrow-left'"
      circle
      size="mini"
      :style="`position: absolute; right: 0; transform: translateX(50%) translateY(-50%); top: 50%; ${isCollapse ? 'transform: rotateZ(180deg) translate(-50%, 50%);' : ''} ${isCollapse ? 'transition: 0.3s;' : 'transition: 0.3s ease 0.3s;'} `"
      @click="handleCollapse"
    ></el-button>
  </div>
</template>
<script>
export default {
  computed: {
    isCollapse() {
      return this.$store.getters['sidebar/isProductSidebarCollapse'];
    },
  },
  methods: {
    handleSelect(page) {
      this.$router.push('/' + page);
    },
    handleCollapse() {
      if (this.isCollapse) {
        this.$store.commit('sidebar/setIsProductSidebarCollapse', false);
      } else {
        this.$store.commit('sidebar/setIsProductSidebarCollapse', true);
      }
    }
  }
};
</script>

<style scoped>
  .el-menu-vertical-demo > .el-menu-item.is-active {
    border-right: 2px solid #409EFF;
    transition: 0.3s;
    background: #ecf5ff;
  }

  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 100%;
  }
</style>
